import { Box } from '@mui/system';
import React from 'react';
import About from '../About/About';
import Achievements from '../Achievements/Achievements';
// import Academic from '../Academic/Academic';
import Blogs from '../Blogs/HomePageBlogs';
import Contact from '../Contact/Contact';
// import Experience from '../Experience/Experience';
import Home from '../Home/Home';
import Projects from '../Projects/HomePageProjects';
import Skills from '../Skills/Skills';

const HomePage = () => {
    return (
        <Box>
           <Home/>
           <About />
           <Skills/>
           <Achievements/>
           <Projects/>
           {/* <Experience /> */}
           <Blogs/>
           {/* <Academic/> */}
           <Contact/>
        </Box>
    );
};

export default HomePage;